module.exports = __webpack_public_path__ + "static/media/32.f0b5c055.png";